// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fOwZ","input":"styles_input__2WuMA"};